function loaderInit () {
    window.addEventListener('load', () => {
        const loaderEl = document.querySelector('.c-page-loader');
        const lcEl = document.querySelector('.layout-container');
        if (loaderEl && lcEl) {
            loaderEl.classList.add('hide');
            lcEl.classList.add('show');
        }
    });
}



export { loaderInit };
